export default {
    set: "modals.set",
    reset: "modals.reset",
    downloadCode: "modals.download.code",
    update: "modals.update",
    wallet: {
        preset: "modals.wallet.preset",
        tab: "modals.wallet.tab"
    },
    email_confirmation: {
        stage: "modals.email_confirmation.stage",
        error: "modals.email_confirmation.error",
        toggle_button: "modals.email_confirmation.toggle_button",
        toggle_resend: "modals.email_confirmation.toggle_resend",
        update_stage: "modals.email_confirmation.update_stage",
        update_user: "modals.email_confirmation.update_user"
    },
    phone_confirmation: {
        stage: "modals.phone_confirmation.stage",
        error: "modals.phone_confirmation.error",
        toggle_button: "modals.phone_confirmation.toggle_button",
        toggle_resend: "modals.phone_confirmation.toggle_resend",
        update_stage: "modals.phone_confirmation.update_stage",
        update_user: "modals.phone_confirmation.update_user"
    },
    account_recovery: {
        stage: "modals.account_recovery.stage",
        error: "modals.account_recovery.error",
        update_stage: "modals.account_recovery.update_stage",
        toggle_button: "modals.account_recovery.toggle_button",
        toggle_resend: "modals.account_recovery.toggle_resend"
    }
}